// Client-side Sentry noise filter — the `ignoreErrors` entries for the
// Sentry.init in index.js. Kept in its own module so the patterns are
// unit-testable (index.js renders the app on import). Sentry merges these
// with its own built-in default filters; they drop matching events in the
// browser, before anything is sent.
//
// Only add patterns here for errors that provably cannot originate from our
// code and that no change of ours can prevent. A pattern that is too broad
// hides real bugs.

export const SENTRY_IGNORE_ERRORS = [
  // "Object Not Found Matching Id:N, MethodName:update, ParamCount:4" — not
  // ours (the string appears nowhere in this repo). It is the JS↔.NET bridge
  // of CefSharp, the Chromium embed used by .NET desktop apps and email
  // link-scanning agents (Outlook-adjacent security scanners): the host app
  // injects bound objects into every page it loads, and when it disposes one
  // the bridge rejects a pending promise with that bare string. Our SDK's
  // global onunhandledrejection handler then reports it as "Non-Error promise
  // rejection captured with value: …" against whatever public page the
  // embedded browser was on (in production: /register, the entry URL the
  // storefront and emailed links funnel to). No real user is affected — the
  // rejected promise belongs to the host app's bridge, not to our page.
  //
  // Sentry's own default filters cover only the `MethodName:simulateEvent`
  // variant, anchored to the full wrapped message; the production events are
  // `MethodName:update`, so we match any method name, unanchored (bare or
  // wrapped form alike).
  /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/,
];
